<ds-themed-item-detail-preview [item]="item"
                        [object]="object"
                        [status]="status"></ds-themed-item-detail-preview>

<ds-workflowitem-actions [object]="dso"></ds-workflowitem-actions>

